import { useState } from 'react';
import {
  RepairClientConfirmModal,
  RepairCompleteModal,
  RepairDeleteModal,
  RepairSetUpdateModal,
} from '../../design-system';
import { RepairsPage, RepairsHeader, RepairsBody } from './RepairsComponents';

interface RepairsProps {
  containerId?: string;
  handleRowClick?: (data: any) => void;
}

export const Repairs = ({ containerId, handleRowClick }: RepairsProps) => {
  const [totalCount, setTotalCount] = useState(0);
  const [totalPrice, setTotalPrice] = useState('');

  return (
    <>
      <RepairsPage innerScroll>
        <RepairsHeader
          totalCount={totalCount}
          totalPrice={totalPrice}
          handleRowClick={handleRowClick}
        />
        <RepairsBody
          setTotalCount={setTotalCount}
          setTotalPrice={setTotalPrice}
          containerId={containerId}
          handleRowClick={handleRowClick}
        />
      </RepairsPage>
      <RepairSetUpdateModal />
      <RepairClientConfirmModal />
      <RepairDeleteModal />
      <RepairCompleteModal />
    </>
  );
};
